import * as React from "react";
const SvgFiRrArrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrows_svg__a)">
      <path
        fill="#062147"
        d="M23.351 10.253a17 17 0 0 0-.619-.67L20.487 7.3a1 1 0 0 0-1.426 1.4l2.251 2.29.008.01H13V2.745l2.233 2.194a1 1 0 0 0 1.4-1.426l-2.279-2.24A18 18 0 0 0 13.68.65a2.58 2.58 0 0 0-1.652-.644L12 0h-.01a2.58 2.58 0 0 0-1.737.647c-.263.233-.513.462-.67.62L7.3 3.512A1 1 0 1 0 8.7 4.94l2.29-2.25.01-.009V11H2.68l.015-.015L4.94 8.7a1 1 0 1 0-1.426-1.4L1.274 9.577c-.163.163-.392.413-.624.675A2.58 2.58 0 0 0 0 11.99V12c0 .01.005.02.006.03.012.609.24 1.195.644 1.652.233.262.461.512.618.67l2.245 2.284a1 1 0 0 0 1.426-1.4L2.744 13H11v8.32l-.015-.014L8.7 19.062a1 1 0 1 0-1.4 1.425l2.278 2.24c.163.162.413.39.675.623a2.587 2.587 0 0 0 3.43 0c.262-.233.511-.46.67-.619l2.283-2.244a1 1 0 1 0-1.4-1.425L13 21.256V13h8.256l-2.2 2.233a1 1 0 1 0 1.426 1.4l2.24-2.279c.162-.163.39-.413.623-.675a2.59 2.59 0 0 0 .006-3.426"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrows_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrows;
